import src from "IMAGE";
export default { src, width: 480, height: 474, blurWidth: 0, blurHeight: 0};
